var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLirariLogoBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 766,
    viewBox: "0 0 501 766",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37619 685.015C-3.97494 630.966 355.239 450.492 366.093 509.12",
    stroke: "white",
    strokeWidth: 3,
    strokeDasharray: "6 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.869 733.403C257.903 733.403 319.539 671.814 319.539 595.842C319.539 519.87 257.903 458.284 181.869 458.284C105.836 458.284 44.1992 519.87 44.1992 595.842C44.1992 671.814 105.836 733.403 181.869 733.403Z",
    fill: "#242424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M322.05 8.63102V22.2007C330.416 125.35 519.125 283.433 491.824 520.017C453.275 312.166 403.247 313.18 322.05 274.908V22.2007C321.674 17.5673 321.661 13.0448 322.05 8.63102Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M321.735 7.57996L319.591 588.014M322.05 8.63102V22.2007M322.05 8.63102C321.661 13.0448 321.674 17.5673 322.05 22.2007M322.05 8.63102V274.908M322.05 8.63102C313.028 111.307 520.351 272.806 491.824 520.017M322.05 22.2007C330.416 125.35 519.125 283.433 491.824 520.017M322.05 22.2007V274.908M491.824 520.017C453.275 312.166 403.247 313.18 322.05 274.908M181.869 733.403C257.903 733.403 319.539 671.814 319.539 595.842C319.539 519.87 257.903 458.284 181.869 458.284C105.836 458.284 44.1992 519.87 44.1992 595.842C44.1992 671.814 105.836 733.403 181.869 733.403Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0005 568.944C116.757 657.759 161.245 685.255 252.534 705.676M75.312 521.312C139.926 605.796 203.035 643.496 291.232 667.011M115.692 483.767C179.987 567.55 223.608 594.869 311.132 618.369M168.655 465.48C212.017 528.352 243.164 547.528 307.495 561.1M254.843 487.879C96.5548 468.57 36.3106 582.922 107.84 703.436M255.173 488.874C156.788 510.516 90.413 620.57 107.84 703.995M256.151 488.061L109.214 704.366M255.899 488.251C275.325 590.692 198.036 694.749 108.853 705.296M256.017 487.625C340.116 634.561 256.507 734.609 108.688 705.186",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M365.762 508.218C376.115 562.268 16.9003 742.742 6.04541 684.114",
    stroke: "white",
    strokeWidth: 3,
    strokeDasharray: "6 12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLirariLogoBackground);
export default __webpack_public_path__ + "static/media/lirari-logo-background.02e7f2e4bf36652f7e81233d99faca3f.svg";
export { ForwardRef as ReactComponent };